import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Alert from "../v3/Alert";
import { drApi } from "../../services/drApi";

function CredentialExpiryAlert() {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    drApi
      .myCredentials()
      .then((res) => {
        if (live) setRows(Array.isArray(res?.data) ? res.data : []);
      })
      .catch((err) => {
        if (live) setError(err?.response?.data?.message || err.message);
      });
    return () => {
      live = false;
    };
  }, []);

  if (error) {
    return <Alert tone="warn">Could not verify credential status: {error}</Alert>;
  }
  if (rows === null) return null;

  const now = Date.now();
  const in30 = now + 30 * 86400 * 1000;
  const approved = rows.filter((r) => r.status === "APPROVED");
  const pending = rows.filter((r) => r.status === "PENDING");

  const expiredByStatus = rows.filter((r) => r.status === "EXPIRED");
  const expiredByDate = approved.filter((r) => new Date(r.expiry_date).getTime() <= now);
  const expired = [...expiredByStatus, ...expiredByDate];
  const expiringSoon = approved.filter((r) => {
    const t = new Date(r.expiry_date).getTime();
    return t > now && t <= in30;
  });

  if (expired.length) {
    return (
      <Alert tone="danger">
        <strong>Credential expired.</strong> Approval actions are blocked until a Platform Manager reviews a refreshed license.{" "}
        <Link to="/dr/credentials" style={{ color: "inherit", textDecoration: "underline" }}>
          Renew credential
        </Link>
      </Alert>
    );
  }
  if (expiringSoon.length) {
    const soonest = expiringSoon.reduce((a, b) =>
      new Date(a.expiry_date) < new Date(b.expiry_date) ? a : b
    );
    const daysLeft = Math.ceil(
      (new Date(soonest.expiry_date).getTime() - now) / (86400 * 1000)
    );
    return (
      <Alert tone="warn">
        <strong>Credential expires in {daysLeft} day{daysLeft === 1 ? "" : "s"}.</strong>{" "}
        Upload a refreshed license on the Credentials page to avoid access disruption.
      </Alert>
    );
  }
  if (!approved.length && pending.length) {
    return (
      <Alert tone="info">
        Your credential is awaiting Platform Manager review. Approval workflows unlock once a credential reaches APPROVED status.
      </Alert>
    );
  }
  if (!rows.length) {
    return (
      <Alert tone="warn">
        No credentials on file. Upload a CCO, EMD or UDP license on the Credentials page to unlock approval workflows.
      </Alert>
    );
  }
  return null;
}

export default CredentialExpiryAlert;
